import { render, staticRenderFns } from "./OptionsPopover.vue?vue&type=template&id=dcf0795a&scoped=true&"
import script from "./OptionsPopover.vue?vue&type=script&lang=js&"
export * from "./OptionsPopover.vue?vue&type=script&lang=js&"
import style0 from "./OptionsPopover.vue?vue&type=style&index=0&id=dcf0795a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf0795a",
  null
  
)

export default component.exports